import { render } from "./ProLabore.vue?vue&type=template&id=50c0f078&scoped=true"
import script from "./ProLabore.vue?vue&type=script&lang=js"
export * from "./ProLabore.vue?vue&type=script&lang=js"

import "./ProLabore.vue?vue&type=style&index=0&id=50c0f078&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50c0f078"]])

export default __exports__